import { JsonObject, JsonProperty } from "typescript-json-serializer";
import {GeoICONS} from "../components/icon/icon";
import {SearchSourceQueryConfiguration} from "./search-configuration";


@JsonObject()
export class ActionBaseConfiguration {
    /**
     * Set this property to `true` to display a spinner icon.
     *
     * @default false
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-support-actions-ActionBase.html#active)
     */
    @JsonProperty()
    declare active?: boolean;
    /**
     * This adds a CSS class to the [ActionButton's]
     * (https://developers.arcgis.com/javascript/latest/api-reference/esri-support-actions-ActionButton.html) node.
     *
     * [Read more...]
     * (https://developers.arcgis.com/javascript/latest/api-reference/esri-support-actions-ActionBase.html#className)
     */
    @JsonProperty()
    declare className?: string;
    /**
     * Indicates whether this action is disabled.
     *
     * @default false
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-support-actions-ActionBase.html#disabled)
     */
    @JsonProperty()
    declare disabled?: boolean;

    /**
     * Calcite icon used for the action.
     *
     * @default null
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-support-actions-ActionBase.html#icon)
     */
    @JsonProperty()
    declare icon?: string;

    /**
     * The name of the ID assigned to this action.
     *
     * [Read more...]
     * (https://developers.arcgis.com/javascript/latest/api-reference/esri-support-actions-ActionBase.html#id)
     */
    @JsonProperty()
    declare id?: string;
    /**
     * The title of the action.
     *
     * [Read more...]
     * (https://developers.arcgis.com/javascript/latest/api-reference/esri-support-actions-ActionBase.html#title)
     */
    @JsonProperty()
    declare title: string;
    /**
     * Specifies the type of action.
     *
     * @default null
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-support-actions-ActionBase.html#type)
     */
    @JsonProperty()
    declare type: "button" | "slider" | "toggle";
    /**
     * Indicates if the action is visible.
     *
     * @default true
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-support-actions-ActionBase.html#visible)
     */
    @JsonProperty()
    declare visible: boolean;
    /**
     * *Geo.js Property*
     * Target url
     */
    @JsonProperty()
    declare url?: string;

    /**
     * *Geo.js Property*
     * Query for additional data
     */
    @JsonProperty()
    declare query?: SearchSourceQueryConfiguration;

    constructor() {}
}

@JsonObject()
export class ActionButtonConfiguration extends ActionBaseConfiguration {
    /**
     * The URL to an image that will be used to represent the action.
     *
     * [Read more...]
     * (https://developers.arcgis.com/javascript/latest/api-reference/esri-support-actions-ActionButton.html#image)
     */
    @JsonProperty()
    declare image?: string;

    /**
     * *Geo.js Property*
     * Icon name
     */
    @JsonProperty()
    declare icon?: GeoICONS;

    constructor() {
        super();
    }
}

@JsonObject()
export class ActionToggleConfiguration extends ActionBaseConfiguration {
    /**
     * Indicates the value of whether the action is toggled on/off.
     *
     * @default false
     *
     * [Read more...](https://developers.arcgis.com/javascript/latest/api-reference/esri-support-actions-ActionToggle.html#value)
     */
    @JsonProperty()
    declare value: boolean;

    constructor() {
        super();
    }
}

@JsonObject()
export class ActionSliderConfiguration extends ActionBaseConfiguration {
    constructor() {
        super();
    }
}
